<div style="height : calc(100% - 3px)">
  <div class="main-container white-rounded-container">
    <div class="table-button-container">
      <button mat-icon-button color="primary" aria-label="collapse" (click)="refresh()">
        <mat-icon>refresh</mat-icon>
      </button>
      <div class="component-title">
        {{arrayTitle}}
      </div>
        <div class="component-title header-waring inline-display" *ngIf="!isParentAlive" style="width:300px !important">
          Fenêtre principale introuvable
          <mat-icon matTooltip="fenêtre accessible exclusivement en lecture" matTooltipClass="tool-tip-size-0-9-em"
            matTooltipPosition="above" style="margin-left : 8px ; margin-top: 5px;">warning_amber
          </mat-icon>
        </div>
      <!-- <button mat-icon-button color="primary" aria-label="collapse" (click)="saveOrder()" [disabled]="!orderHasModification">
                <mat-icon>save</mat-icon>
              </button>
              <button mat-icon-button color="primary" aria-label="collapse" (click)="addObject()">
                <mat-icon>add</mat-icon>
              </button>
              <button mat-icon-button color="primary" aria-label="expand" (click)="removeSelectedObjects()" [disabled]="ordersSelected?.length == 0">
                <mat-icon>delete</mat-icon>
              </button> -->
    </div>
    <app-prime-ng-array-d4 [apiUrlSend]="" [filterFields]="[]" [arrayName]="poolName" [type]="type"
      nullArrayDisplayText="Aucune donnée" [columnsDefinition]="columnsDefinition" [objectList]="arrayList"
      [loading]="loading" columnResizeMode="expand">
    </app-prime-ng-array-d4>
  </div>
</div>